import Utility from '@/Common/Utility';
import Validator from '@/Common/Validator';
import FieldOptionService from '@/Common/FieldOptionService';
 
 
function TControlBase() {


    if (this.m_Attribute == null) {
        this.m_Attribute = TControlBase.Attribute();
    }
    else if (this.m_Attribute.TControlBaseAttributeFlag == null) {
        this.m_Attribute = TControlBase.Attribute(this.m_Attribute);
    }

    this.PropertyChangeTimeSet = {
    };

    this.DefaultWatcherSet = {};


    this.OptionValueSet = {};

    if (this.Keep == true || this.Keep == 'true') {

        if (this.KeyName == null) {
            throw ("TControlBase:: property 'KeyName'  not set !");
        }


        //if (this.GetValue == null) {
        //    throw ("TControlBase:: method 'GetValue' does not exist !");
        //}

        //if (this.SetValue == null) {
        //    throw ("TControlBase:: method 'SetKey' does not exist !");
        //}
    }

    this.GetKeyPath = function () {
        return "KeptKey_" + this.$route.fullPath + "__" + this.KeyName;
    };
 

    this.Initialize = function () {


 
        this.$watch(
            "value",
            function (newValue, oldValue) {
                this.DoOnWatchValueChange(newValue, oldValue);
            }.bind(this)
        );


        this.$watch(
            "Attribute",
            function (newValue, oldValue) {
                this.DoOnWatchAttributeChange(newValue, oldValue);
            }.bind(this)
        );




        for (let propertyName in this.m_Attribute) {

            if (this.DefaultWatcherSet[propertyName] == null) {
                if (this[propertyName] != null) {
                    this.$watch(
                        propertyName,
                        function (newValue, oldValue) {
                            this.DoOnWatchPropertyChange(propertyName, newValue, oldValue);
                        }.bind(this)
                    );
                }
            }
        }



        if (this.Keep == true || this.Keep == 'true') {

            if (this.KeyName == null) {
                throw ("TControlBase:: property 'KeyName'  not set !");
            }

            //if (this.GetValue == null) {
            //    throw ("TControlBase:: method 'GetValue' does not exist !");
            //}

            //if (this.SetValue == null) {
            //    throw ("TControlBase:: method 'SetKey' does not exist !");
            //}
        }
 

        //把 props 裡面傳進來的值 都放到 m_Attribute 裡面去
        for (let propertyName in this.m_Attribute) {

 

            if (this[propertyName] != null) {

                this.m_Attribute[propertyName] = this.NormalizePropertyValue(propertyName, this[propertyName]);


                this.SetOppositeProperty(propertyName);
            }
        }

        if (this.m_Attribute.Validator != null) {
            this.m_Attribute.ValidateHandler = this.m_Attribute.Validator;
        }


      

        //先設定到 m_Value 
        this.m_Value = this.NormalizeValue(this.value);

        if (this.m_Value != null) {
            setTimeout(
                function () {

                    if (this.SetValue != null) {
                        this.SetValue(this.m_Value, false);//不要 Trigger Change
                    }
                    else if (this.$refs.Element != null) {
                        this.$refs.Element.value = this.m_Value;
                    }
                    else {
                        this.$el.value = this.m_Value;
                    }

                    this.$forceUpdate();
                }.bind(this),
                10
            );
        }




        if (this.hasOwnProperty("m_Text")) {

            if (typeof (this.m_Value) == "object" && Utility.IsDateObject(this.m_Value)
                &&
                (this.m_Attribute.DataType + "").toLowerCase() == "date"
            ) {
                this.m_Text = Utility.GetDateText(this.m_Value);
            }
            else {
                this.m_Text = this.m_Value;
            }
        }

        //#region FinalEnabled FinalVisible FinalRequired Final
        Object.defineProperty(
            this,
            "FinalEnabled",
            {
                get: function () {
                    let authEnabled = true;

                    return this.m_Attribute.Enabled && authEnabled;
                }
            }
        );

        Object.defineProperty(
            this,
            "FinalVisible",
            {
                get: function () {
                    return this.m_Attribute.Visible;
                }
            }
        );

        Object.defineProperty(
            this,
            "FinalRequired",
            {
                get: function () {
                    return this.m_Attribute.Required;
                }
            }
        );

        Object.defineProperty(
            this,
            "FinalReadOnly",
            {
                get: function () {
                    return this.m_Attribute.ReadOnly;
                }
            }
        );
        //#endregion

 
        this.PrepareSoltOptions();
 
        this.PrepareForOptionName();

        this.PrepareForComplexOptionName();

        this.$forceUpdate();
    };//end  this.Init = function () {



 
    this.DoOnMounted = function () {


        this.$el.Component = this;

        if (this.$refs.Element != null) {
            this.$refs.Element.Component = this;
        }


        if (this.m_Attribute.Keep == "true" || this.m_Attribute.Keep == true) {
            this.LoadValue();
        }
    };


    this.DoOnValueInput = function (e) {

        this.PropertyChangeTimeSet["TheCurrentValue"] = new Date();

        this.$emit("input", e.target.value);

        this.ClearError();
    };


    this.DoOnValueChange = function (e) {
        let triggerValue = null;
        let normalizedValue;
        let validateResult;

        if (this.PropertyChangeTimeSet["TheCurrentValue"] != null &&
            (new Date() - this.PropertyChangeTimeSet["TheCurrentValue"]) < 20
        ) {
            return;
        }

        if (this.GetValue != null) {
            triggerValue = this.GetValue();
        }
        else if (e != null && e.target != null) {
            triggerValue = e.target.value;
        }
        else {
            triggerValue = this.m_Value;
        }

        if (this.$options._componentTag == "t-select") {
            this.m_Value = triggerValue;
        } 


  

        normalizedValue = this.NormalizeValue(triggerValue);

        if ((this.m_Attribute.DataType + "").toLocaleLowerCase() == "date") {
            if (isNaN(normalizedValue)) {
                return;
            }
        }

        if (this.Keep == "true" || this.Keep == true) {
            this.StoreValue();
        }

        validateResult = this.DoValidate();

        if (validateResult == true) {
            this.PropertyChangeTimeSet["TheCurrentValue"] = new Date();

            this.$emit("input", normalizedValue);
            this.$emit("change", normalizedValue);
        }
    };


    this.DoOnWatchValueChange = function (newVal, oldVal) {

         
        if (this.PropertyChangeTimeSet["TheCurrentValue"] != null &&
            (new Date() - this.PropertyChangeTimeSet["TheCurrentValue"]) < 100
        ) {
            return;
        }
  


        this.PropertyChangeTimeSet["TheCurrentValue"] = new Date();

        if (this.IsDataTypeString() && Utility.IsDateObject(newVal)) {
            this.$el.value = Utility.GetDateText(newVal);
            this.m_Value = this.$el.value;
        }
        else {
            this.$el.value = newVal;
            this.m_Value = newVal;
        }

        if (this.SetValue != null) {
            this.SetValue(this.m_Value);
        }

 
        if (this.hasOwnProperty("m_Text")) {
            if (typeof (this.m_Value) == "object" && Utility.IsDateObject(this.m_Value)
                &&
                this.m_Attribute.DataType == "Date"
            ) {
                this.m_Text = Utility.GetDateText(this.m_Value);
            }
            else {
                this.m_Text = this.m_Value;
            }
        }


        if (this.$refs.Element != null) {
            this.$refs.Element.value = this.m_Value;
        }

        if (this.m_Attribute.Keep == true) {
            this.StoreValue();
        }

 

        this.m_Value = this.NormalizeValue(this.value);



        if (this.m_Value != null) {
            setTimeout(
                function () {

                    if (this.SetValue != null) {
                        this.SetValue(this.m_Value, false);//不要 Trigger Change
                    }
                    else if (this.$refs.Element != null) {
                        this.$refs.Element.value = this.m_Value;
                    }
                    else {
                        this.$el.value = this.m_Value;
                    }

                    this.$forceUpdate();
                }.bind(this),
                10
            );
        }

         

        this.$emit("input", this.m_Value);

        this.ClearError();
    };


    this.DoOnWatchAttributeChange = function (newVal, oldVal) {
        Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);

        this.$forceUpdate();

        if (this.m_Value != null && this.m_Value != '') {
            setTimeout(
                () => {
                    this.$refs.Element.value = this.m_Value;
                },
                10
            );
        }
    };


    this.DoOnWatchPropertyChange = function (propertyName, newVal, oldVal) {

 

        if (this.PropertyChangeTimeSet[propertyName] != null &&
            (new Date() - this.PropertyChangeTimeSet[propertyName]) < 50
        ) {
            return;
        }



        this.PropertyChangeTimeSet[propertyName] = new Date();

        this.m_Attribute[propertyName] = this.NormalizePropertyValue(propertyName, newVal);

        if (propertyName == "Options") {
            Utility.TouchArray(this.m_Attribute.Options);
        }
        else if (propertyName == "OptionName") {
            this.PrepareForOptionName();
        }
        else if (propertyName == "ComplexOptionName") {
            this.PrepareForComplexOptionName();
        }
        else if (propertyName == "Validator") {
            this.m_Attribute.Validator = newVal;
            this.m_Attribute.ValidateHandler = newVal;
        }

        this.SetOppositeProperty(propertyName);


        this.$forceUpdate();
    };

    this.Validate = function () {
        let result;

        result = this.DoValidate();

        return result;
    };

    this.DoValidate = function () {
        let normalizedValue;
        let validateResult;
        let result;


        if (this.m_Attribute.ValidateHandler != null) {

            validateResult = this.m_Attribute.ValidateHandler(this.m_Value)

            if (validateResult.Success != true) {
                Validator.ShowErrorMessage(validateResult.Message);
                Validator.ShowMessageInErrorMessageElement(this.$el, validateResult.Message);
                return;
            }
        }

        result = Validator.ValidateElement(this.$el);
  
        return result;
    };

    this.SetOppositeProperty = function (propertyName) {

        if (propertyName == "Nullable" || propertyName == "nullable") {
            this.m_Attribute.Required = !this.m_Attribute.nullable;
        }
        else if (propertyName == "Required") {
            this.m_Attribute.nullable = !this.m_Attribute.Required;
        }
        else if (propertyName == "Enabled") {
            this.m_Attribute.disabled = !this.m_Attribute.Enabled;
        }
        else if (propertyName == "Disabled" || propertyName == "disabled") {
            this.m_Attribute.Enabled = !this.m_Attribute.disabled;
        }
    };


    this.NormalizePropertyValue = function (propertyName, propertyValue) {
        let normalizedValue = null;

        if (propertyName == null) {
            throw "propertyName is null !";
        }


        switch (propertyName) {
            case "Options":
                if (propertyValue != null) {
                    normalizedValue = propertyValue;
                }
                else {
                    normalizedValue = [];
                }
                break;

            case "ReadOnly":
            case "Visible":
            case "Keep":
            case "AutoTrim":
            case "nullable":
            case "Nullable":
            case "Required":
            case "Enabled":
            case "disabled":
            case "Disabled":
                if (propertyValue != null) {
                    if (
                        (propertyValue + "").toLowerCase() == "true") {
                        normalizedValue = true;
                    }
                    else {
                        normalizedValue = false;
                    }
                }
                else {

                    if (propertyName == "nullable" || propertyName == "Nullable" || propertyName == "Disabled" || propertyName == "disabled" ) {
                        normalizedValue = true;
                    }
                    else {
                        normalizedValue = false;
                    }

                }
                break;


            case "RepeatColumns":
            case "MaxLength":
            case "MinLength":
                if (typeof (propertyValue) == "string") {
                    normalizedValue = new Number(propertyValue);
                }
                else {
                    normalizedValue = propertyValue;
                }
                break;

            case "MaxValue":
            case "MinValue":

                if (this.IsDataTypeNumber() && typeof (propertyValue) == "string") {
                    normalizedValue = new Number(propertyValue);
                }
                else {
                    normalizedValue = propertyValue;
                }
                break;

            default:
                normalizedValue = propertyValue;
                break;
        }



        return normalizedValue;
    };


    this.ConvertToBoolean = function (val) {
        let result = null;

        if (val != null) {

            this.m_Value == "true" || this.m_Value == "True" || this.m_Value == 1 || this.m_Value == "1" || this.m_Value == "on"

            if (typeof (val) == "string") {
                val = val.toLowerCase();

                if (val.toLowerCase() == "true" ||
                    val.toLowerCase() == "1" ||
                    val.toLowerCase() == "on"  
                ) {
                    result = true;
                }
                else {
                    result = false;
                }
            }
            else if (typeof (val) == "number") {

                if (val == 1) {
                    result = true;
                }
                else {
                    result = false;
                }
            }
            else if (typeof (val) == "boolean") {
                result = val;
            }

            return result;
        }
    };


    this.IsDataTypeString = function () {
        let isNumber = false;
        let dataType = "";

        if (this.DataType != null) {
            dataType = this.DataType.toLowerCase();
        }

        if (
            dataType == "string" ||
            dataType == "text" ||
            dataType == ""
        ) {
            isNumber = true;
        }

        return isNumber;
    };

    this.IsDataTypeNumber = function () {
        let isNumber = false;
        let dataType = "";

        if (this.DataType != null) {
            dataType = this.DataType.toLowerCase();
        }

        if (
            dataType == "int" ||
            dataType == "number" ||
            dataType == "float" ||
            dataType == "decimal"
        ) {
            isNumber = true;
        }

        return isNumber;
    };


    this.NormalizeValue = function (theValue) {
        let normalizedValue = null;
        let dataType = "";


        normalizedValue = theValue;

        if (this.m_Attribute.DataType != null) {
            dataType = this.m_Attribute.DataType.toLowerCase();
        }

        if (theValue != null) {
            if (
                dataType == "int" ||
                dataType == "number" ||
                dataType == "float" ||
                dataType == "decimal"
            ) {

                if (typeof (theValue) == "number" && theValue == 0) {
                    normalizedValue = 0;
                }
                else if (theValue == "") {
                    normalizedValue = null;
                }
                else {
                    normalizedValue = new Number(theValue);
                }
            }
            else if (dataType == "date" || dataType == "datetime") {

                if (theValue == "" ) {
                    normalizedValue = null;
                }
                else if (typeof (theValue) == "string") {

                    if (theValue.indexOf("/Date(") == 0) {
                        let theValueMilliseconds = parseInt(theValue.replace(/\D/igm, ""));

                        normalizedValue = new Date(theValueMilliseconds);
                    }
                    else if (Utility.IsIso8601Text(theValue)) {
                        normalizedValue = Utility.ConvertIso8601TextToDate(theValue);
                    }
                    else {
                        normalizedValue = new Date(theValue.replace(/\//g,'-'));
                    }
                }
                else {
                    normalizedValue = theValue;
                }
            }
            else if (dataType == "boolean" || dataType == "bool") {
                normalizedValue = this.ConvertToBoolean(theValue);
            }
            else if (dataType == null || dataType == "" || dataType == "string" || dataType == "text") {

                if (this.m_Attribute.AutoTrim == true) {
                    normalizedValue = theValue.trim();
                }
            }
        }//end if (theValue != null ) {


        return normalizedValue;
    };//end this.NormalizeValue = function (theValue) {

    this.LoadValue = function () {
        let resolveHandler = null;
        let resultPromise = new Promise(resolve => {
            resolveHandler = resolve;
        });
        let keyValue;
        let keyPath;



        if (this.KeyName == null || this.KeyName == '') {
            throw ("property 'KeyName'  not set !");
        }

        keyPath = this.GetKeyPath();
        if ((keyValue = Utility.GetBag(keyPath)) != null) {

            if (this.SetValue != null) {
                this.SetValue(keyValue, false);
            }
            else {
                setTimeout(
                    () => {
                        this.m_Value = keyValue ;
                        //this.$el.value = keyValue;

                        this.$emit("input", this.m_Value);

                        if (this.m_Attribute.TriggerChange) {
                            this.$emit("input", this.m_Value );
                            this.$emit("change", this.m_Value );
                        }

                        this.$forceUpdate();
                    },
                   100
                );

            }

            if (resolveHandler != null) {
                resolveHandler("ok");
            }

            this.$forceUpdate();
        }

        return resultPromise;
    };


    this.StoreValue = function () {
        let keyValue;
        let keyPath;


        if (this.KeyName == null || this.KeyName == '') {
            throw ("property 'KeyName'  not set !");
        }

        keyPath = this.GetKeyPath();

        if (this.GetValue != null) {
            keyValue = this.GetValue();
        }
        else {
            keyValue = this.m_Value;
        }


        if (keyValue == null) {
            keyValue = "";
        }

        Utility.SaveBag(keyPath, keyValue);

    };


    this.ClearError = function () {
        if (this.$el.nextSibling != null &&
            this.$el.nextSibling.nodeType == 1
        ) {

            if (this.$el.nextSibling.classList.contains("error_message") ||
                this.$el.nextSibling.classList.contains("ErrorMessage")
            ) {
                this.$el.nextSibling.innerHTML = "";
            }
        }
    };


    this.GetOptionAbility = function (option) {
        let ability = true;

        if (this.OptionAbilityHandler != null) {

            ability = this.OptionAbilityHandler(option.Value);
        }

        return ability;
    };


    this.PrepareSoltOptions = function () {
        let vnodes;
        let i


        //if (this.Options == null) {
        //    this.Options = [];
        //}



        if (this.$slots != null && this.$slots.default != null) {
            vnodes = this.$slots.default;

            for (i = 0; i < vnodes.length; i++) {
                let optionValue = null;
                let optionText = "";

                if (vnodes[i].tag == "option") {
                    if (vnodes[i].data.attrs.value != null) {
                        optionValue = vnodes[i].data.attrs.value;
                    }

                    if (vnodes[i].children != null && vnodes[i].children.length > 0) {

                        optionText = "";

                        for (let j = 0; j < vnodes[i].children.length; j++) {
                            if (vnodes[i].children[j].tag == "img") {
                                optionText += this.RenderImgNodeHtml(vnodes[i].children[j]);
                            }
                            else {
                                optionText += vnodes[i].children[j].text;
                            }
                        }

                        if (optionValue == null) {
                            optionValue = optionText;
                        }
                    }

                    this.m_Attribute.Options.push(
                        {
                            Value: optionValue,
                            Text: optionText
                        }
                    );
                }
            }

            this.PrepareOptionValueTextSet();

            this.$forceUpdate();
        }
    };//end  this.ParepareSoltOptions = function() {


    this.RenderImgNodeHtml = function (vnode) {
        let imgNodeHtml = "<img ";

        if (vnode.data != null && vnode.data.attrs != null) {
            for (let attr in vnode.data.attrs) {
                imgNodeHtml += " " + attr + "='" + vnode.data.attrs[attr] + "' ";
            }
        }

        imgNodeHtml += " />";

        return imgNodeHtml;
    };


    this.PrepareForOptionName = function () {

 
 
        if (this.m_Attribute.OptionName != null) {
            let dataLangauge;
            let useCacheOption = true;


            if (this.m_Attribute.CacheOption != null &&
                (
                    this.m_Attribute.CacheOption == false ||
                    (this.m_Attribute.CacheOption + "").toLowerCase() == "false"
                )
            ) {
                useCacheOption = false;
            }

            if (window.location.href.indexOf("Backend") > 0) {
                dataLangauge = this.$util.GetBag("BackendDataLanguage");
            }
            else {
                dataLangauge = this.$util.GetBag("DataLanguage");
            }

            

            FieldOptionService.GetFieldOptions(
                this.m_Attribute.OptionName,
                dataLangauge,
                useCacheOption,
                function (options) {

                    this.m_Attribute.Options.length = 0;

                    this.m_Attribute.Options.push(...options);
                    this.$forceUpdate();


                    this.PrepareOptionValueTextSet();

                    this.UpdateElementByAttribute();

       
                    if (this.m_Value != null) {
                        setTimeout(
                            function () {

                                if (this.SetValue != null) {
                                    this.SetValue(this.m_Value, false);//不要 Trigger Change
                                }
                                else if (this.$refs.Element != null) {
                       
                                    this.$refs.Element.value = this.m_Value  ;
                                }
                                else {

                                    this.$el.value = this.m_Value ;
                                }

                                this.$forceUpdate();
                            }.bind(this) ,
                            10
                        );
                    }

                }.bind(this)
            );
        };
    };//end



    this.PrepareForComplexOptionName = function () {

        if (this.m_Attribute.ComplexOptionName != null) {
            let dataLangauge;
            let useCacheOption = true;
            let controlValue = null;


            //if (this.m_Attribute.CacheOption != null &&
            //    (
            //        this.m_Attribute.CacheOption == false ||
            //        (this.m_Attribute.CacheOption + "").toLowerCase() == "false"
            //    )
            //) {
            //    useCacheOption = false;
            //}

            if (window.location.href.indexOf("Backend") > 0) {
                dataLangauge = this.$util.GetBag("BackendDataLanguage");
            }
            else {
                dataLangauge = this.$util.GetBag("DataLanguage");
            }

 
            if (this.ControlType == "Label") {
                if (this.GetValue != null) {
                    controlValue = this.GetValue();
                }
                else {
                    controlValue = m_Value;
                }
            }


            
            FieldOptionService.GetComplexFieldOptions(
                this.m_Attribute.ComplexOptionName,
                dataLangauge,
                controlValue,
                useCacheOption,
            ).then(
                function (options) {
                    this.m_Attribute.Options.length = 0;

                    this.m_Attribute.Options.push(...options);
                    //this.m_Attribute.Options = options;


                    this.PrepareOptionValueTextSet();


                    if (this.SetValue != null) {
                        this.SetValue(this.m_Value, false);//不要 Trigger Change
                    }
                    else if (this.$refs.Element != null) {
                        this.$refs.Element.value = this.m_Value;
                    }
                    else {
                        this.$el.value = this.m_Value;
                    }

                    this.$forceUpdate();

                    if (this.ResetValue != null) {
                        setTimeout(
                            function () {
                                this.ResetValue();
                                this.UpdateElementByAttribute();
                                
                                this.$forceUpdate();
                            }.bind(this),
                            100
                        );
                    }
                    else {
                        //Do Nothing
                    }

                    /*try {*/

                    this.UpdateElementByAttribute();
                    //}
                    //catch (ex) {
                    //    debugger;
                    //}

                    this.$forceUpdate();
                }.bind(this)
            );
        }
    };


    this.PrepareOptionValueTextSet = function () {
        let option;
        let i;


        this.OptionValueSet = {};

        for (i = 0; i < this.m_Attribute.Options.length; i++) {

            option = this.m_Attribute.Options[i];

            if (option.Value != null) {
                this.OptionValueSet[option.Value + ''] = option.Text;
            }
        }
    };


    this.GetOptionText = function (optionValue) {
        let optionText = "";

        optionText = this.OptionValueSet[optionValue+''];

        return optionText;
    };

    //problem
    this.OnNewValue = function (newVal) {


        if (this.ComplexOptionName != null) {
            let dataLangauge;
            let useCacheOption = true;
            let controlValue = null;


            if (window.location.href.indexOf("Backend") > 0) {
                dataLangauge = this.$util.GetBag("BackendDataLanguage");
            }
            else {
                dataLangauge = this.$util.GetBag("DataLanguage");
            }

            if (FieldOptionService.IsCacheComplexOptionContainAllValue(this.ComplexOptionName, dataLangauge, newVal) == true) {
                this.m_Attribute.Options = FieldOptionService.GetCacheComplexOptions(
                    this.ComplexOptionName,
                    dataLangauge,
                    newVal
                );


                this.PrepareOptionValueTextSet();

                if (this.ResetValue != null) {
                    setTimeout(
                        function () {
                            this.ResetValue();
                            this.UpdateElementByAttribute();
                            this.$forceUpdate();
                        }.bind(this),
                        100
                    );
                }

                this.UpdateElementByAttribute();

                this.$forceUpdate();

                return;
            }

            if (this.CacheOption != null &&
                (
                    this.CacheOption == false ||
                    (this.CacheOption + "").toLowerCase() == "false"
                )
            ) {
                useCacheOption = false;
            }


            controlValue = newVal;

            FieldOptionService.GetComplexFieldOptions(
                this.ComplexOptionName,
                dataLangauge,
                controlValue,
                useCacheOption,
            ).then(
                function (options) {


                    this.m_Attribute.Options = options;


                    if (this.ResetValue != null) {
                        setTimeout(
                            function () {
                                this.ResetValue();
                                this.UpdateElementByAttribute();
                                this.$forceUpdate();
                            }.bind(this),
                            100
                        );
                    }


                    this.PrepareOptionValueTextSet();

                    this.UpdateElementByAttribute();

                    this.$forceUpdate();
                }.bind(this)
            );
        }

    }.bind(this);//end   this.OnNewValue = function () {



    //設定 Component 自訂 Watcher
    this.SetWatchers = function (watcherObject) {

    };

    this.Initialize();
}


TControlBase.BaseProps = [
    "value", //值

    "nullable", "Required", //是否 必填

    "ReadOnly" , //唯獨
    "Enabled", "disabled", //是否 可修改(或唯獨)

    "Visible", 
     
    "Name", //Field 名稱 通常是 Debug 用

    "AutoTrim", //true or false , 是否自動移除 前後空白 , 只有手動輸入的 元件才會需要

    "MinValue", "MaxValue", //允許之最大值 最小值 範圍 , DataType 為 int 或 number 才需要判斷  , 只有手動輸入的 元件才會需要

    "MinLength", "MaxLength", //文字長度 限制 , 只有手動輸入的 元件才會需要

    "Validator", "ValidateHandler", //驗證 Value 是否合法的 Handler , 常用在日期

    "Attribute", //其他屬性

    "DataType", //資料型態 : int, number, string(text) , date,datetime ... , 用再回傳 值 出去時的轉換

    "Options",//直接指定 選項
    "OptionName", "ComplexOptionName", //選項來源名稱
    "CacheOption", //暫存選項 以提高效率
    "ExcludeOptionValue", //排除顯示 之 選項值

    "OptionAbilityHandler", //判斷一個 Option 使否可以被選取 , 也就是可以呈現 但不能點選

    "Keep", "KeyName", //判斷是否保留 Value , 重整畫面時 可以重現 Value

    "TriggerChange", //true or false, 是否 觸發 change 事件

    "RepeatColumns",  //呈現問題 , 應該可以用別的方式取代
];


TControlBase.Attribute = function (attribute) {

    let m_Attribute = {
        Required: false,
        ReadOnly: false,
        //Disabled: false,
        disabled: false,
        Enabled: true,
        Nullable: true,
        nullable:true,
        Name: null,
        AutoTrim: false,
        MinValue: null,
        MaxValue: null,

        MinLength: null,
        MaxLength: null,

        Validator:null,
        ValidateHandler: null,
        DataType: null,
        Options: [],
        OptionName: null,
        ComplexOptionName: null,
        CacheOption: false,
        ExcludeOptionValue: null,
        OptionAbilityHandler: null,
        Visible:true,
        Keep: false,
        KeyName: null,
        TriggerChange: false,
        RepeatColumns: 1000,

        TControlBaseAttributeFlag: "",

    }


    if (attribute != null) {
        for (let pName in attribute) {
            if (attribute[pName] != null) {
                m_Attribute[pName] = attribute[pName];
            }
        }
        //Object.assign(m_Attribute, attribute);
    }


    return m_Attribute;
}//end TControlBase.Attribute = function (attribute) {


TControlBase.Watch = function (vueComponent, watchObject) {

    //vueComponent.DefaultWatcherSet = watchObject;


    return watchObject;
};

export default TControlBase;
